import React from 'react';
import { Container, Button } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { useState } from 'react';
import ResalesRequestService from '../../services/resales-request';
import ActionRequestService from '../../services/action-request';
import {ActionStatus,FundType} from '../../helpers/Enum/index';

export default function(){
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [currentCompany, setCurrentCompany] = useState(JSON.parse(localStorage.getItem('currentCompany')));

  const [flow, setFlow] = useState(null);
  const [funds, setFunds] = useState([]);
  const [spendings, setSpendings] = useState(null);
  
  useEffect(()=>{
    getFlow();
    getStatement();
  },[]);

  useEffect(()=>{
    if(flow && funds.length>0){
      setSpendings(buildFullDemonstrative(Object.values(flow.action_status),funds));
    }
  },[flow,funds]);

  const getFlow = () => {
    let request = ActionRequestService.getFlow(1);
    request.then(data=>{
      setFlow(data.data.data);
    });
  };

  const getStatement = () => {
    let filters = {
      'embed':'actions',
      'type_id':FundType().Marketing,
      'fiscal_year_id':user.fiscal_year.id
    };
    let request = ResalesRequestService.getCompanyFunds(currentCompany?currentCompany.id:user.currentCompany.id,{params:{...filters}});
    request.then(data=>{
      let result = data.data.data;
      setFunds(result.funds);
    });
  }
  
  const buildFullDemonstrative = (actionStatus, funds) => {
    
    let spendings = {
      'actions':[],
      'completed':{},
      'total-others':{},
      'others':{},
      'total-completed':{},
      'available-fund':{},
      'free-fund':{},
    };

    actionStatus.forEach(item => {
      funds.forEach(fund => {

        if(!spendings['total-others'][fund.id])
          spendings['total-others'][fund.id] = 0;

        let actions = fund.actions.filter(action=>action.action_status_id===item.id);
  
        switch(item.id){
          case ActionStatus().Finalizada:
            
            actions.forEach(action=>{
              spendings['actions'].push(action);
            })
            spendings['total-completed'][fund.id] = actions.reduce((total, value) => {
              return total + value.pivot.value;
            },0);
          break;
          case ActionStatus().Cancelada:
          break;
          default:
            if(!spendings['others'][item.id])
              spendings['others'][item.id] = {};
            spendings['others'][item.id]['status'] = item.name;
            spendings['others'][item.id][fund.id] = actions.reduce((total, value) => {
              return total + value.pivot.value;
            },0);
            spendings['total-others'][fund.id] += spendings['others'][item.id][fund.id];
        }
      });
    });
    let dates = spendings['actions'].map(a=>{return a.pay_date}).filter((a,k,self)=>self.indexOf(a)===k).sort()
    dates.forEach(date=>{
      funds.forEach(fund=>{
        if(!spendings['completed'][date])
        spendings['completed'][date] = {};
        spendings['completed'][date][fund.id] = spendings['actions']
          .filter(a=>a.pay_date===date && a.pivot.fund_id===fund.id)
          .reduce((total, value) => {
            return total + value.pivot.value;
          },0);
      });
    });

    funds.map(fund=>{
      spendings['available-fund'][fund.id] = fund.pivot.value - spendings['total-completed'][fund.id];
      spendings['free-fund'][fund.id] = spendings['available-fund'][fund.id] - spendings['total-others'][fund.id];
    });
    return spendings;
  }

  return (<>
    <Container>
      <h2>Extrato Detalhado</h2>
      <table id="datatable-buttons" class="table table-bordered table-striped mb-0" style={{borderCollapse:'collapse'}}>
        <thead>
          <tr>
            <th></th>
            <th></th>
            {funds.map((item,k)=>{
              return(
              <th key={k}>{item.name}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td class="table-1"><b>accumulatedValue</b></td>
            {funds.map((item,k)=>{
              return(
              <td key={k}><b>{item.pivot.value}</b></td>
              );
            })}
          </tr>
          <tr>
            <td><a href="javascript:void(0)" class="cursor-pointer"><i class="fe-plus-circle"></i></a></td>    
            <td class="table-1">amountsPaid</td>
            {spendings?Object.values(spendings['total-completed']).map((item,k)=>{
              return(
              <td key={k} className="text-success">{item}</td>
              );
            })
            :''}                                                   
          </tr>
          <tr >
            <td colspan="6" class="hiddenRow" style={{padding:0,backgroundColor:'#fafafa'}}>
              <div class="accordian-body" id="linha1">
                <table class="table table-borderless">
                    <tbody>
                      {spendings?Object.values(spendings['completed']).map((actions,k)=>{
                        return(
                        <tr key={k}>
                          <td class="w-30px"></td>
                          <td class="table-1 text-center"><b>{Object.keys(spendings['completed'])[k]}</b></td>
                          {Object.values(actions).map((action,k)=>{
                            return(
                              <td key={k} class="table-2 text-success"><b>{action}</b></td>
                            );
                          })}
                        </tr>
                        );
                      }):''}
                    </tbody>
                </table>
              </div>
            </td>
          </tr>
      
        </tbody>
      </table>

      <table class="table table-bordered table-striped mb-0" style={{borderCollapse:'collapse'}}>
        <tbody>
          <tr>
            <td style={{padding:'21px'}}></td>
            <td class="table-1"><b>availableFund</b></td>
            {spendings?Object.values(spendings['available-fund']).map((item,k)=>{
              return(
              <td key={k} class="table-2"><b>{item}</b></td>    
              );
            }):''}
          </tr>
          {spendings?Object.values(spendings['others']).map((item,k)=>{
            return(
              <tr key={k}>
                <td></td>
                <td>{item['status']}</td>
                {funds.map((fund,k)=>{
                  return(
                    <td key={k} class="text-danger">{item[fund.id]}</td>
                  );
                })}
              </tr>
            );
          }):''}
          <tr>
            <td></td>
            <td class="table-1"><b>freeFund</b></td>
            {spendings?Object.values(spendings['free-fund']).map((item,k)=>{
              return(
                <td key={k} class="table-2"><b>{item}</b></td>    
              );
            }):''}
          </tr>
        </tbody>
      </table>
    </Container>
  </>);
};
